import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { URLSearchParams } from '@angular/http';

import { oAuth } from '../../providers/oAuth';
import { Doctor } from '../../dataObjects/Customer';

import { DatePipe } from '@angular/common';

import { GlobalVariable } from '../../common/global';
@Component({
  selector: 'app-doctor-search',
  templateUrl: './doctor-search.component.html',
  styleUrls: ['./doctor-search.component.css']
})
export class DoctorSearchComponent {

  DoctorSearch: string
  Doctors: [Doctor]
  SelectedDoctor: Doctor
  PharmaciesSelectedValue: string
  loading: boolean

  DoctordisplayedColumns = ['colPharmName', 'colLastName', 'colFirstName', 'colNPI', 'colStreet'];


  constructor(private http: HttpClient,
    public dialogRef: MatDialogRef<DoctorSearchComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
    this.loading = false;
    this.PharmaciesSelectedValue = this.data.PharmaciesSelectedValue;
    this.SelectedDoctor = this.data.Doctor
  }

  DoctorSearchSubmit() {

    this.loading = true;

    const token = JSON.parse(sessionStorage.getItem('data'));
    const tokenPayload = <oAuth>(token);

    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
    };

    let DoctorSearchRequest = {
      Pharmacy_Id: this.PharmaciesSelectedValue,
      SearchString: this.DoctorSearch
    }

    var body = JSON.stringify(DoctorSearchRequest)

    this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneDoctorSearch", body.toString(), options)
      .subscribe(
        (response) => {
          const resp = <[Doctor]>response
          this.Doctors = resp;
        },
        (err) => {
          /* this function is executed when there's an ERROR */
          this.loading = false;

        },
        () => {
          /* this function is executed when the observable ends (completes) its stream */
          //this.openSnackBar("Set Batches has completed.", "OK");
          this.loading = false;
        }
      );
  }

  setClickedRow(Doctor: Doctor) {
    this.SelectedDoctor = Doctor;
    this.dialogRef.close(Doctor);
  }

}



// WEBPACK FOOTER //
// ./src/app/common/doctor-search/doctor-search.component.ts